// RoundButton.js
import React from 'react';


const RoundButton = ({ imageSrc, altText, onClick }) => {
    return (
        <button className="round-button" onClick={onClick}>
            <img src={imageSrc} alt={altText} />
        </button>
    );
};

export default RoundButton;